





















































































import Vue from 'vue'
import moment from 'moment-timezone'

import { mapActions, mapGetters } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import { ActionNames, GetterNames as ExerciseGetterNames, GetterNames } from '@/store/modules/exercise/keys'

import { generatePdfFromHtml } from '@/utils/pdf-export'
import { getCsvDownloadFunction } from '@/http/utils'
import { VitalStatsDisplayOptions } from '@/constants/exercise-program'
import { getPatientName } from '@/utils/patients'

import { ExportDialogs } from '@/constants/exports'
import { Timeouts } from '@/constants/timeouts'

import ExerciseSessionReportHead from '@/components/exercises/components/ExerciseSessionReportHead.vue'
import ExerciseSessionReportExerciseTable from '@/components/exercises/components/ExerciseSessionReportExerciseTable.vue'
import ExerciseSessionReportVitalsData from '@/components/exercises/components/ExerciseSessionReportVitalsData.vue'
import IsGeneratingExportDialog from '@/components/dialog/IsGeneratingExportDialog.vue'

export default Vue.extend({
  components: {
    ExerciseSessionReportHead,
    ExerciseSessionReportVitalsData,
    ExerciseSessionReportExerciseTable,
    IsGeneratingExportDialog,
  },
  inheritAttrs: false,
  data() {
    return {
      vitalStatsDisplayToggle: VitalStatsDisplayOptions.Table,
      isDeletingPatientExercise: false,
      isInitialized: false,
      isGeneratingExport: false,
      isGeneratingExportDialogText: ExportDialogs.Pdf,
    }
  },
  computed: {
    showLoading() {
      return !this.isInitialized || this.isDeletingPatientExercise
    },
    vitalStatsDisplayOptions() {
      return [
        {
          text: VitalStatsDisplayOptions.Table,
          isActive: this.vitalStatsDisplayToggle === VitalStatsDisplayOptions.Table,
        },
        {
          text: VitalStatsDisplayOptions.Graph,
          isActive: this.vitalStatsDisplayToggle === VitalStatsDisplayOptions.Graph,
        },
      ]
    },
    patientName() {
      if (this.$attrs['current-patient']) {
        return getPatientName(this.$attrs['current-patient'])
      }
      return ''
    },
    patientId() {
      return this.$route.params.patient_id
    },
    patientExercises() {
      return this[ExerciseGetterNames.sortedExercises].filter(ex => ex.patientId === this.patientId)
    },
    patientExercisesForChosenDateRange() {
      return this.patientExercises.filter(ex => {
        return moment(ex.exerciseDate).valueOf() > this.$attrs['start-timestamp']
      })
    },
    exportAllPatientExercisesForChosenPatientOptions() {
      return [
        {
          label: 'Export to PDF',
          icon: 'mdi-file-pdf-box',
          action: this.exportAllPatientExercisesForChosenPatientToPdf,
        },
        {
          label: 'Export to CSV',
          icon: 'mdi-google-spreadsheet',
          action: this.exportAllPatientExercisesForChosenPatientToCsv,
        },
      ]
    },
    ...mapGetters(ModuleNames.exercise, [GetterNames.sortedExercises]),
  },
  async mounted() {
    await this[ActionNames.getExercisesByPatient](this.patientId)
    this.isInitialized = true
  },
  methods: {
    toggleVitalStatsDisplay(opt: VitalStatsDisplayOptions.Table | VitalStatsDisplayOptions.Graph) {
      this.vitalStatsDisplayToggle = opt
    },
    async exportSinglePatientExerciseToPdf(e) {
      this.isGeneratingExportDialogText = ExportDialogs.Pdf
      this.isGeneratingExport = true
      const exercise = this.patientExercises.find(exercise => exercise.id === e)
      await generatePdfFromHtml({
        filename: `Agartee Patient Exercise Report (${this.patientName} - ${exercise.exerciseDate})`,
        source: this.$refs[`pdfPatientExercise_${e}`][0],
        pagebreak: {
          avoid: 'tr',
        },
      })
      setTimeout(() => {
        this.isGeneratingExport = false
      }, Timeouts.OneSecond)
    },
    async exportAllPatientExercisesForChosenPatientToPdf() {
      this.isGeneratingExportDialogText = ExportDialogs.Pdf
      this.isGeneratingExport = true
      await generatePdfFromHtml({
        filename: `Agartee Patient Exercise Report (${this.patientName} - All Sessions)`,
        source: this.$refs.pdfAllPatientExercises,
        pagebreak: {
          avoid: 'tr',
          after: '.pdf-page-break-after',
        },
      })
      setTimeout(() => {
        this.isGeneratingExport = false
      }, Timeouts.OneSecond)
    },
    async exportSinglePatientExerciseToCsv(e) {
      this.isGeneratingExportDialogText = ExportDialogs.Csv
      this.isGeneratingExport = true
      const singlePatientExerciseCsv = getCsvDownloadFunction({
        path: `patient-exercises/${this.patientId}/${e}`,
      })
      await singlePatientExerciseCsv()
      setTimeout(() => {
        this.isGeneratingExport = false
      }, Timeouts.OneSecond)
    },
    async exportAllPatientExercisesForChosenPatientToCsv(e) {
      this.isGeneratingExportDialogText = ExportDialogs.Csv
      this.isGeneratingExport = true
      const allPatientExerciseCsv = getCsvDownloadFunction({
        path: `patient-exercises/${this.patientId}`,
      })
      await allPatientExerciseCsv()
      setTimeout(() => {
        this.isGeneratingExport = false
      }, Timeouts.OneSecond)
    },
    async deletePatientExercise(e): Promise<void> {
      this.isDeletingPatientExercise = true
      await this[ActionNames.deleteExercise]({ exerciseId: e })
      this.isDeletingPatientExercise = false
    },
    ...mapActions(ModuleNames.exercise, [ActionNames.getExercisesByPatient, ActionNames.deleteExercise]),
  },
})
